// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3yrSl","file":"styles_file__2X_VN"};